import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import CloseIcon from "@material-ui/icons/Close";

const style = {
  position: "absolute",
  top: "6rem",
  left: "50%",
  transform: "translate(-50%, 0)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid rgba(var(--text-heading-dark))",
  boxShadow: 24,
  borderRadius: "1rem",
  p: 4,
};

export default function InquirySuccessModal(props) {
  return (
    <div>
      <Modal open={props.open}>
        <Box sx={style} className="advSearchModalContainer">
          <div className="advSearchModalContainerHeading mb-3">
            <h5>Thank You</h5>
            <CloseIcon className="pointer" onClick={props.handleClose} />
          </div>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Thank you for your enquiry, our team will get back to you shortly.
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}
